import React from 'react';

const ExpendTypeAddPage = React.lazy(() => import('pages/ExpendType/ExpendTypeAddPage'));
const ExpendTypePage = React.lazy(() => import('pages/ExpendType/ExpendTypePage'));

const ExpendTypeRoutes = [
  {
    path: '/expend-type',
    exact: true,
    name: 'Danh sách loại phiếu chi',
    function: 'MD_EXPENDTYPE_VIEW',
    component: ExpendTypePage,
  },
  {
    path: '/expend-type/add',
    exact: true,
    name: 'Thêm mới loại phiếu chi',
    function: 'MD_EXPENDTYPE_ADD',
    component: ExpendTypeAddPage,
  },
  {
    path: '/expend-type/edit/:expend_type_id',
    exact: true,
    name: 'Chỉnh sửa loại phiếu chi',
    function: 'MD_EXPENDTYPE_EDIT',
    component: ExpendTypeAddPage,
  },
  {
    path: '/expend-type/view/:expend_type_id',
    exact: true,
    name: 'Xem loại phiếu chi',
    function: 'MD_EXPENDTYPE_VIEW',
    component: ExpendTypeAddPage,
  },
];

export default ExpendTypeRoutes;
